import { motion } from "framer-motion";

/**
 * Reusable page hero: dramatic image + big serif title + subtitle.
 * Used across About, Nature, Weather, etc.
 */
export default function PageHero({ eyebrow, title, subtitle, image, align = "left" }) {
  return (
    <section className="relative min-h-[70svh] w-full overflow-hidden bg-[color:var(--np-bg-2)] flex items-end">
      <motion.img
        src={image}
        alt={title}
        initial={{ scale: 1.15, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 sunset-scrim-strong" />
      <div className={`relative z-10 max-w-[1600px] mx-auto px-6 md:px-10 pb-16 md:pb-24 pt-40 w-full ${align === "center" ? "text-center" : ""}`}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="font-mono-tech text-[10px] tracking-[0.4em] uppercase text-[color:var(--np-live)] mb-6"
        >{eyebrow}</motion.div>
        <h1 className="font-serif-display font-light text-[color:var(--np-bg)] text-[10vw] md:text-[7vw] leading-[0.92] tracking-tighter max-w-6xl drop-shadow-[0_4px_30px_rgba(36,18,9,0.55)]">
          <span className="mask-line block">
            <motion.span initial={{ y: "110%" }} animate={{ y: "0%" }} transition={{ duration: 1.1, ease: [0.16,1,0.3,1], delay: 0.15 }} className="inline-block">{title}</motion.span>
          </span>
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.8 }}
            className="mt-8 max-w-2xl text-lg text-[color:var(--np-bg)]/95 drop-shadow-[0_2px_10px_rgba(36,18,9,0.45)]"
          >{subtitle}</motion.p>
        )}
      </div>
    </section>
  );
}
